export const PortfolioData = [
    {
        id: 0,
        name: 'ApplyForMe Website',
        skill: 'WEB DEVELOPMENT | Job Web | REACT',
        img: '/img/Screenshot (125).png',
        detail: `A Website built together with other team members based on team task in the zuri internship. click on the button below to preview live page`,
        link: 'https://applyforme.app',
    },
    {
        id: 1,
        name: 'User DashBoard',
        skill: 'WEB DEVELOPMENT | Dashboard | REACT',
        img: '/img/Screenshot (124).png',
        detail: `A Website built based on personal programming challenge in the zuri internship. click on the button below to preview live page`,
        link: 'https://paulizekor-hng9-stage2-project.netlify.app',
    },
    {
        id: 2,
        name: 'Meta BNB',
        skill: 'WEB DEVELOPMENT | Nft | REACT',
        img: '/img/Screenshot (123).png',
        detail: `A Website built based on personal programming challenge in the zuri internship. click on the button below to preview live page`,
        link: 'https://paulizekor-hng9-stage3-project.netlify.app',
    },

    {
        id: 3,
        name: "Country Finder Website",
        img: "img/Screenshot (103).png",
        skill: "WEB DEVELOPMENT | Countries | REACT",
        link: "https://pauls-country-finder.netlify.app",
        detail:
            "A project with noframe works, This project was rebuilt from JAVASCRIPT to REACT user friendly. Click on the button below to preview live page.",
    },
    {
        id: 4,
        name: "Space Tourism",
        img: "img/spaceT.png",
        skill: "WEB DEVELOPMENT | Space | JAVSCRIPT",
        link: "https://pauls-space.netlify.app",
        detail:
            "This project was based on a self motivation to test my learning progress in JAVASCRIPT and it was a success. Click on the button below to preview live page.",
    },
    {
        id: 5,
        name: "E-Commerce-App",
        img: "img/Screenshot (104).png",
        skill: "WEB DEVELOPMENT | W-commerce | REACT",
        link: "https://paul-e-commerce.netlify.app",
        detail:
            "A project with noframe works, This project is an e-commerce app for the sales of phones. Click on the button below to preview live page.",
    },
    {
        id: 6,
        name: "Cloudolle",
        img: "img/cloudolle.png",
        skill: "WEB DEVELOPMENT | Landing Page | NEXT.JS",
        link: "https://cloudolle.vercel.app",
        detail:
            "A front-end Job Test. Used NEXTJS to build this very responsive Homepage/Landing Page. Click on the button below to preview live page.",
    },
    {
        id: 7,
        name: "Parallel Landing Page Website",
        img: "img/Screenshot (54).png",
        skill: "WEB DEVELOPMENT | Parallel | PURE CSS3",
        link: "https://princeizekor.github.io/Mycode/employees.html",
        detail:
            "A project built to test my knowledge of responsiveness an UI/UX. Click on the button below to preview live page.",
    },
    {
        id: 8,
        name: "Parallel Landing Page Website",
        img: "img/Screenshot (55).png",
        skill: "WEB DEVELOPMENT | Parallel | PURE CSS3",
        link: "https://princeizekor.github.io/Mycode/outer.html",
        detail:
            "A project built to test my knowledge of responsiveness an UI/UX. Click on the button below to preview live page.",
    },
    {
        id: 9,
        name: "Password Generating App",
        img: "img/Screenshot (102).png",
        skill: "WEB DEVELOPMENT | Generates Passwords | REACT",
        link: "https://paul-password-generator.netlify.app",
        detail:
            "A project built with REACT frame work, This project was create to test my first react knowledge. Click on the button below to preview live page.",
    },
    {
        id: 10,
        name: "Url Shortening Website",
        img: "img/Screenshot (66).png",
        skill: "WEB DEVELOPMENT | Shortens Any Url | JAVASCRIPT",
        link: "https://princeizekor.github.io/link-shorten-website/url.html",
        detail:
            "A project with noframe works, An API website which shortens any link which is passed on to it and return the shortened links in different form. Click on the button below to preview live page.",
    },
    {
        id: 11,
        name: "Weebly",
        img: "img/weebly.png",
        skill: "WEB DEVELOPMENT | Marketing Website | JAVASCRIPT",
        link: "https://anointedosara.github.io/weebly/index.html",
        detail:
            "I and a friend of mine worked on this Weebly landing page together to test our Github pull request ability, We created and tested this awesome project and it was a success increasing my/our knowledge more about how the git commands work. Click on the button below to preview live page.",
    },
    {
        id: 12,
        name: "Api Tracker Map",
        img: "img/Screenshot (67).png",
        skill: "WEB DEVELOPMENT | Map Tracking | JAVASCRIPT",
        link: "https://princeizekor.github.io/ipaddress/",
        detail:
            "A project inspired to inprove my javascript knowledge and real life project,An API website which is able to get your ip location anywhere in the world, resposive and more. Click on the button below to preview live page.",
    },
    {
        id: 13,
        name: "Github Finder App",
        img: "img/Screenshot (101).png",
        skill: "WEB DEVELOPMENT | User Friendly | REACT",
        link: "https://pauls-github-finder.netlify.app",
        detail:
            "A project built with REACT frame work, An API website which gets the details of any user on github and returns back the data collected. Click on the button below to preview live page.",
    },
    {
        id: 14,
        name: "Rest Country Api",
        img: "img/Screenshot (103).png",
        skill: "WEB DEVELOPMENT | Countries | JAVASCRIPT",
        link: "https://princeizekor.github.io/CountriesAll/Countries.html",
        detail:
            "A project built with javaScript, An API website that brings the data of a country when searched, A well built and responsive api website. Click on the button below to preview live page.",
    },
    {
        id: 15,
        name: "Crowd Funding",
        img: "img/Screenshot (51).png",
        skill: "WEB DEVELOPMENT | Landing Page | VANILLA JAVASCRIPT",
        link: "https://princeizekor.github.io/javascriptspace/Crowdfunding.html",
        detail:
            "A project Built to test my javascript skill. Click on the button below to preview live page.",
    },
    {
        id: 16,
        name: "Calculator App",
        img: "img/calculator.png",
        skill: "WEB DEVELOPMENT | Calculator | JAVASCRIPT",
        link: "https://pauls-calculator.netlify.app",
        detail:
            "A project inspired from an online developer site, I created the core functionality of this calculator app and it was a real success and process of more advanced knowledge in javascript. Click on the button below to preview live page.",
    }
]